import React from "react";
import Renderbtn from "./renderButton";
export default function renderDynamicButton({
  wrapClassName,
  page,
  workflow,
  btnMiddleware,
}) {
  const showOldbtn = false;
  const hideBtnbeforeOnprocess = false;
  const disable = false;

  return (
    <div className={wrapClassName}>
      {showOldbtn
        ? workflow.map((item, index) => {
          if (hideBtnbeforeOnprocess) {
            if (
              item.from_main_process_id === 0 ||
              item.from_main_process_id === 33 ||
              item.from_main_process_id === 34 ||
              item.from_main_process_id === 35 ||
              item.from_main_process_id === 1 ||
              item.from_main_process_id === 2 ||
              item.from_main_process_id === 18
            ) {
              return <div></div>;
            }
          }

          if (item.next_main_action_id === 8) {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-light"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <i className="fas fa-times"></i>
                <span>{item.next_main_action_name}</span>
              </button>
            );
          }

          if (item.next_main_action_id === 25) {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <i className="fas fa-edit"></i>
                <span>{item.next_main_action_name}</span>
              </button>
            );
          }

          // Stop time
          if (item.next_main_action_id === 5) {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <i className="fas fa-stopwatch"></i>
                <span>{item.next_main_action_name}</span>
              </button>
            );
          }

          // Start time
          if (item.next_main_action_id === 6) {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-success"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <i className="fas fa-clock"></i>
                <span>{item.next_main_action_name}</span>
              </button>
            );
          }

          // Reject
          if (item.next_main_action_id === 2) {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <i className="fas fa-ban"></i>
                <span>{item.next_main_action_name}</span>
              </button>
            );
          }

          // Approve
          if (item.next_main_action_id === 7) {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-success"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <i className="fas fa-check"></i>
                <span>{item.next_main_action_name}</span>
              </button>
            );
          }

          if (item.next_main_action_id === 17) {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <span>{item.next_main_action_name}</span>
              </button>
            );
          } else if (item.next_main_action_id === 16) {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <span>{item.next_main_action_name}</span>
              </button>
            );
            /* alarm btn request alarm clear  */
          } else if (item.next_main_action_id === 27) {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <i className="fas fa-bell"></i>
                <span>{item.next_main_action_name}</span>
              </button>
            );
            /* alarmclear */
          } else if (item.next_main_action_id === 29) {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-success"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <i className="fas fa-bell"></i>
                <span>{item.next_main_action_name}</span>
              </button>
            );
            /* alarm not clear */
          } else if (item.next_main_action_id === 30) {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <i className="fas fa-bell-slash"></i>
                <span>{item.next_main_action_name}</span>
              </button>
            );
          } else {
            return (
              <button
                key={`btn_action_${index}`}
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <span>{item.next_main_action_name}</span>
                <i className="fas fa-chevron-right"></i>
              </button>
            );
          }
        })
        : workflow.map((item, index) => {
          if (hideBtnbeforeOnprocess) {
            if (
              item.from_main_process_id === 0 ||
              item.from_main_process_id === 33 ||
              item.from_main_process_id === 34 ||
              item.from_main_process_id === 35 ||
              item.from_main_process_id === 1 ||
              item.from_main_process_id === 2 ||
              item.from_main_process_id === 18
            ) {
              return (
                <div key={`btn_none_key_${item.from_main_process_id}`}></div>
              );
            }
          }

          if (
            item.action_data_dynamic &&
            item.action_data_dynamic !== "" &&
            item.action_data_dynamic !== "[]"
          ) {
            const rawRenderbtn = JSON.parse(item.action_data_dynamic);
            const renderBtn = rawRenderbtn.web[page];
            return (
              <Renderbtn
                key={`render_btn_dynamic_${index}`}
                renderBtn={renderBtn}
                index={index}
                btnMiddleware={btnMiddleware}
                item={item}
                disable={disable}
              ></Renderbtn>
            );
          } else {
            return (
              <button
                key={`btn_action_new${index}`}
                type="button"
                className="btn btn-sm btn-light"
                onClick={() => btnMiddleware(item)}
                disabled={disable}
              >
                <span>{item.next_main_action_name}</span>
              </button>
            );
          }
        })}
    </div>
  );
}
